import { render, staticRenderFns } from "./JoinSelectNew.vue?vue&type=template&id=0861bb4c&"
import script from "./JoinSelectNew.vue?vue&type=script&lang=js&"
export * from "./JoinSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./JoinSelectNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports